import React, { useState } from "react";
import { Button, Drawer } from "antd";
import AddNew from "./AddNew";
import { useTranslation } from "react-i18next";
import { withRouter } from "us.common/wIthRouter";
import { useNavigate } from "react-router-dom";

// interface IActivityGroup extends RouteComponentProps {

// }
interface IActivityGroup {}

export default withRouter((props: IActivityGroup) => {
  // const { history } = props;
  const navigate = useNavigate();
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);
  const { t } = useTranslation();

  const AddClickHandler = () => {
    // history.push('/activities');
    navigate("/activities");
  };

  const showDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  return (
    <>
      <p>Hi this is ActivityGroups.Home</p>
      <Button onClick={showDrawer}>Add New</Button>
      <p>{t("US.COLLECTION.ADMIN:ACTIVITYGROUP.TEST")}</p>

      <Drawer
        title="Add New Activity"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerVisible}
        getContainer={false}
        style={{ position: "absolute" }}
      >
        <AddNew />
      </Drawer>
    </>
  );
});
